import { CheetahWS } from './CheetahWS.js'
import { ReqMsg } from './BaseMsg.js'

export async function wsInit (callback) {
    // console.log('ws-init');
    await CheetahWS.getInstance().connWebSocket({
        wsUrl: process.env.REACT_APP_GOLDSOCKET_URL,
        certID: 'C000',
        charSet: 'UTF-8'
    })
    CheetahWS.getInstance().registerSendHandler(reqMsg => {
        // console.log("-->请求报文：" + JSON.stringify(reqMsg));
    })
    CheetahWS.getInstance().registerConnectHandler(() => {
        // let wsUrl = CheetahWS.getInstance().wsConfig.wsUrl + "?Charset=" + CheetahWS.getInstance().wsConfig.charSet + "&CertID=" + CheetahWS.getInstance().wsConfig.certID;
        // console.log('服务器连接中... ' + wsUrl);
    })
    CheetahWS.getInstance().registerOpenHandler(() => {
        // console.log('服务器连接成功！');
    })
    CheetahWS.getInstance().registerCloseHandler(() => {
        // console.log('服务器连接已关闭！');
    })
    CheetahWS.getInstance().registerNotifyHandler(callback)
}

export async function wsSendMsg (contractCode) {
    // console.log('td-contractCode', contractCode);
    // console.log(`{"oper_flag" : "1","list_subs_prod_code" : ${contractCode}}` === '{"oper_flag" : "1","list_subs_prod_code" : ["Ag(T+D)"]}');
    const state = {
        sExchCode: '106110',
        cMsgType: 0,
        sUserID: '',
        sSessionID: '',
        reqBody: `{"oper_flag" : "1","list_subs_prod_code" : ${contractCode}}`
    }
    const reqMsg = new ReqMsg(state.sExchCode)
    reqMsg.cEncryptMode = 0 // 报文加密标志  0:明文
    reqMsg.sExchCode = state.sExchCode // 交易代码
    reqMsg.cMsgType = state.cMsgType // 报文类型  0：客户请求 1：服务端应答 2：服务端推送
    reqMsg.sUserID = state.sUserID // 用户ID
    reqMsg.sSessionID = state.sSessionID // 会话ID
    reqMsg.sSrcJsonMsg = state.reqBody // 业务报文体  字符串Json原文

    // this.addRspMsg("-->请求报文：" + JSON.stringify(reqMsg));
    // console.log('reqMsg :', reqMsg);
    const resMsg = await CheetahWS.getInstance().sendMsgAsync(reqMsg)
    if (resMsg.optionCode == 0) {
        // console.log('--->响应报文(成功):'+ JSON.stringify(resMsg.sBody));
    } else if (resMsg.optionCode == 3) {
        // console.log("-->响应报文(失败)：" + JSON.stringify(resMsg));
    } else {
        // console.log("-->发送失败：" + JSON.stringify(resMsg));
    }
}

// 关闭Ws
export function wsColsed () {
    CheetahWS.getInstance().closeWebSocket()
}
